// A booking link for a named therapy opens the modal in snippets/site-book-dialog.liquid (data-book-therapy,
// data-book-people, or a therapy page's title), and #rita or #rui leaves only that person. Any other goes to the page.
(() => {
  const dialog = document.querySelector('[data-book-dialog]');
  if (!dialog) return;

  const fees = JSON.parse(dialog.querySelector('[data-book-fees]').textContent);

  const therapyOf = (link) =>
    link.dataset.bookTherapy || link.closest('.story-therapy')?.querySelector('h2')?.textContent;

  const open = (link, url) => {
    const therapy = therapyOf(link);
    const named = url.hash.slice(1) || link.dataset.bookPeople;
    const people = named?.split(',').filter(Boolean);
    const line = dialog.querySelector('[data-book-for]');
    line.textContent = therapy ?? '';
    line.hidden = !therapy;
    for (const row of dialog.querySelectorAll('[data-book-person]')) {
      row.hidden = Boolean(people?.length) && !people.includes(row.dataset.bookPerson);
      const whatsapp = row.querySelector('a');
      const message = link.dataset.bookResult
        ? `${link.dataset.bookResult} ${dialog.dataset.messageWith.replace('[quem]', whatsapp.dataset.with)}`
        : dialog.dataset.message
            .replace('[o quê]', therapy ?? dialog.dataset.consultation)
            .replace('[quem]', whatsapp.dataset.with);
      whatsapp.href = `https://wa.me/${whatsapp.dataset.number}?text=${encodeURIComponent(message)}`;
      const fee = fees[therapy]?.[row.dataset.bookPerson];
      row.querySelector('.role').textContent = fee || row.dataset.role;
    }
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    if (dialog.open) {
      if (event.target === dialog || event.target.closest('[data-book-close]')) dialog.close();
      return;
    }
    const link = event.target.closest?.('a[href]');
    if (!link || event.metaKey || event.ctrlKey || link.closest('footer')) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== dialog.dataset.page || !therapyOf(link)) return;
    event.preventDefault();
    open(link, url);
  });
})();
